import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhotoSwipeComponent } from './photo-swipe/photo-swipe.component';
import { PhotoSwipeDirective } from './photo-swipe.directive';
import { PhotoSwipeService } from './photo-swipe.service';
import { closestPolifill } from '@techmore/global';

/** [photoswipe](https://photoswipe.com/documentation/getting-started.html) 的功能包裝模組，
 *  腳本和樣式檔是調整過的不是官方原版。
 * 在引用套件的模組提供 PHOTO_SWIPE_ASSETS 這個依賴項目可以覆寫掉預設的資產載入配置
 * ```typescript
 * {provide: PHOTO_SWIPE_ASSETS, useValue: {
 *   scripts: ['photoswipe.bundle.js'],
 *   styles:  ['photoswipeStyle.bundle.css']
 * }}
 * ```
 */
@NgModule({
  declarations: [
    PhotoSwipeComponent,
    PhotoSwipeDirective
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    PhotoSwipeComponent,
    PhotoSwipeDirective
  ]
})
export class PhotoSwipeModule {
  static forRoot(): ModuleWithProviders<PhotoSwipeModule> {
    return {
      ngModule: PhotoSwipeModule,
      providers: [PhotoSwipeService]
    };
  }

  constructor() {
    closestPolifill();
  }
}